import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Box } from "@mui/material";
import { routes } from "./static/routes";
import { NotFound } from "./component/NotFound";
import Main from "./layout/index";

function App() {
  return (
    <BrowserRouter>
      <Box
        sx={{
          flexGrow: 1,
          width: "100%",
          overflow: "hidden",
        }}
      >
        <Routes>
          <Route
            path="/"
            element={
              <Navigate to="/clinical_team/terms_of_use/v2/en" replace={true} />
            }
          />
          <Route element={<Main />}>
            {routes.map((routeEl) => (
              <Route
                key={`route-${routeEl.id}`}
                path={routeEl.path}
                element={routeEl.element}
              />
            ))}

            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Box>
    </BrowserRouter>
  );
}

export default App;
